(function () {
  function init(root) {
    root = root || document;
    // Reveal on scroll
    var els = root.querySelectorAll('.ppw-reveal:not(.is-in)');
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) { io.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('is-in'); });
    }

    // Flavour (variant) swatches: swap image, label, price, availability
    root.querySelectorAll('[data-ppw-variant-input]').forEach(function (inp) {
      if (inp.dataset.ppwBound) return; inp.dataset.ppwBound = '1';
      inp.addEventListener('change', function () {
        var scope = inp.closest('[data-ppw-product]');
        if (!scope) return;
        var lbl = scope.querySelector('[data-ppw-flav-label]'); if (lbl) lbl.textContent = inp.dataset.title;
        var price = scope.querySelector('[data-ppw-price]'); if (price && inp.dataset.price) price.textContent = inp.dataset.price;
        var img = scope.querySelector('[data-ppw-main-img]');
        if (img && inp.dataset.img) {
          img.style.opacity = 0;
          setTimeout(function () { img.removeAttribute('srcset'); img.src = inp.dataset.img; img.style.opacity = 1; }, 180);
        }
        var btn = scope.querySelector('[data-ppw-atc]');
        if (btn) {
          var ok = inp.dataset.available === 'true';
          btn.disabled = !ok;
          btn.textContent = ok ? btn.dataset.labelAdd : btn.dataset.labelSold;
        }
        if (scope.hasAttribute('data-ppw-pdp') && inp.value) {
          var url = new URL(window.location.href); url.searchParams.set('variant', inp.value);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });

    // PDP thumbnails
    root.querySelectorAll('[data-ppw-thumb]').forEach(function (b) {
      if (b.dataset.ppwBound) return; b.dataset.ppwBound = '1';
      b.addEventListener('click', function () {
        var scope = b.closest('[data-ppw-product]');
        var main = scope.querySelector('[data-ppw-main-img]');
        main.removeAttribute('srcset'); main.src = b.dataset.full;
        scope.querySelectorAll('[data-ppw-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });

    // Quantity steppers
    root.querySelectorAll('.ppw-qty').forEach(function (q) {
      if (q.dataset.ppwBound) return; q.dataset.ppwBound = '1';
      var i = q.querySelector('input');
      q.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(i.value || 1, 10) + (b.dataset.d === '+' ? 1 : -1);
          i.value = Math.max(1, v);
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  if (document.readyState !== 'loading') init(document);
  // Theme editor: re-init when sections are added/re-rendered
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    e.target.querySelectorAll('.ppw-reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('DOMContentLoaded', function () {
      document.querySelectorAll('.ppw-reveal').forEach(function (el) { el.classList.add('is-in'); });
    });
  }
})();
